<template>
    <div class="content-builder-video" :class="[excludeFromPrintClassName]">
        <youtube
            v-if="isYoutubeVideo"
            ref="youtube"
            :video-id="youtubeId"
            class="youtube"
        />

        <video v-else :src="link" controls />
    </div>
</template>

<script>
import { Youtube, getIdFromUrl } from 'vue-youtube';

import getMediaUrl from '@/helpers/getMediaUrl';

export default {
    components: {
        Youtube
    },

    props: {
        value: {
            type: Object,
            required: true
        },

        excludeFromPrintClassName: {
            type: String,
            required: true
        }
    },

    computed: {
        isYoutubeVideo() {
            return (
                this.value.linkOnly &&
                this.value.link.includes('www.youtube.com')
            );
        },

        youtubeId() {
            if (!this.isYoutubeVideo) {
                return null;
            }

            return getIdFromUrl(this.value.link);
        },

        link() {
            return this.value.linkOnly
                ? this.value.link
                : getMediaUrl(this.value.videoData);
        }
    }
};
</script>
